
const CONTENT = {
  hero: {
    welcome: 'Welcome to Yes Boss',
    subtitle: 'People powered by people',
    requestAccess: 'Request Access',
    userLimitMessage: 'We\'ve reached our current user capacity.',
    emailRequestMessage: 'Request early access by submitting your email below:',
    emailPlaceholder: 'Enter your email',
    requestSuccess: 'Access request submitted successfully!',
    requestError: 'Please enter an email address',
    invalidEmail: 'Please enter a valid email address',
    requestedAccess: 'Request has been made, we\'ll get back to you at {email}',
    changeEmail: 'Use a different email',
    altText: '{BRAND_NAME} Logo',
    signInButton: 'Sign in with Google',
    accessError: 'Access denied. Please contact support.'
  },
  features: {
    items: [
      {
        title: 'Smart AI Assistant',
        description: 'Get personalized assistance with your tasks and questions'
      },
      {
        title: 'Real-time Chat',
        description: 'Connect with real people instantly'
      },
      {
        title: '24/7 Support',
        description: 'Always available when you need help'
      },
      {
        title: 'Secure Communication',
        description: 'Your privacy and security are our priority'
      }
    ]
  },
  about: {
    cards: [
      {
        title: 'Our Mission',
        content: 'To empower people through intelligent assistance'
      },
      {
        title: 'Our Values',
        content: 'Integrity, Innovation, and Excellence'
      },
      {
        title: 'Our Team',
        content: 'Passionate experts dedicated to your success'
      }
    ]
  },
  demo: {
    buttonText: 'Try Demo Chat'
  },
  bionic: {
    label: 'Bionic reading',
    tooltip: 'This helps people with ADD and ADHD focus more easily on what they\'re reading.'
  },
  footer: {
    copyright: '© {year} Yes Boss. All rights reserved.'
  },
  toast: {
    success: 'Success',
    error: 'Error',
    accessDenied: 'Access denied. Please contact support.',
    requestError: 'Error submitting request. Please try again.',
    loadingError: 'Error loading content. Please refresh the page.'
  },
  formMessages: {
    requestSuccess: 'Access request submitted successfully!',
    requestError: 'Please enter an email address',
    invalidEmail: 'Please enter a valid email address',
    requestedAccess: 'Request has been made, we\'ll get back to you at {email}',
    changeEmail: 'Use a different email',
    userLimit: 'We\'ve reached our current user capacity.',
    emailRequest: 'Request early access by submitting your email below:',
    emailPlaceholder: 'Enter your email',
    requestAccess: 'Request Access',
    signIn: 'Sign in with Google',
    accessError: 'Access denied. Please contact support.'
  }
};

export default CONTENT;
